import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import router from '@/router'



export default /*#__PURE__*/_defineComponent({
  __name: 'AuthBtn',
  setup(__props) {

const handleAuth = () => {
    router.push({name:'auth'})
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "no-auth",
    onClick: handleAuth,
    style: {"margin-right":"10px"}
  }, [
    _createElementVNode("button", null, [
      _createVNode(_component_v_icon, {
        name: "la-user-circle",
        fill: "#fff"
      }),
      _createTextVNode(" Acceder / Registro")
    ])
  ]))
}
}

})